import { render, staticRenderFns } from "./ManagementTerritorialAreas.vue?vue&type=template&id=14d9388e&"
import script from "./ManagementTerritorialAreas.vue?vue&type=script&lang=ts&"
export * from "./ManagementTerritorialAreas.vue?vue&type=script&lang=ts&"
import style0 from "./ManagementTerritorialAreas.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports